module.exports = __webpack_public_path__ + "img/promo.bc40672b.svg";